import React from 'react';

export function NameColumnFormatter(cellContent, row) {
  return (
    <div
      style={{
        display: 'flex-inline',
        justifyContent: 'left',
        alignItems: 'left',
      }}
    >
      <span style={{ fontStyle: 'bold', fontSize: 'large' }}>
        {row.name} {row.subProduct > 0 ? '*' : ''}
      </span>
      <div
        style={{
          fontStyle: 'italic',
          fontSize: 'small',
        }}
      >
        {row.productCode}
      </div>
    </div>
  );
}
